import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { Product } from '@wconcept/wconcept-common/models/renewal/product';

interface RelatedPrdModalState {
  type: 'RelatedPrdModal';
  placement: 'right' | 'bottom';
  className: string;
  products: Product[];
  value: {
    type: string;
  };
  timestamp: number;
}

interface ModalStore {
  relatedPrdModalState: RelatedPrdModalState | null;
  isRestored: boolean; // 복원 상태 추적
  setRelatedPrdModalState: (
    state: Omit<RelatedPrdModalState, 'timestamp'>
  ) => void;
  clearRelatedPrdModalState: () => void;
  shouldRestoreRelatedPrdModal: () => boolean;
  markAsRestored: () => void; // 복원 완료 표시
}

const initialRelatedPrdModalState: RelatedPrdModalState | null = null;

export const useRelatedPrdModalStore = create<ModalStore>()(
  persist(
    (set, get) => ({
      relatedPrdModalState: initialRelatedPrdModalState,
      isRestored: false,

      setRelatedPrdModalState: state => {
        set({
          relatedPrdModalState: {
            ...state,
            timestamp: Date.now(),
          },
          isRestored: false, // 새 모달 상태 설정 시 복원 플래그 리셋
        });
      },

      clearRelatedPrdModalState: () => {
        set({
          relatedPrdModalState: initialRelatedPrdModalState,
          isRestored: false,
        });
      },

      shouldRestoreRelatedPrdModal: () => {
        const { relatedPrdModalState, isRestored } = get();

        // 이미 복원되었으면 복원하지 않음
        if (isRestored) {
          return false;
        }

        // 모달 상태가 없으면 복원하지 않음
        if (!relatedPrdModalState || !relatedPrdModalState.timestamp) {
          return false;
        }

        // 5분 이내의 상태만 복원
        const isRecent =
          Date.now() - relatedPrdModalState.timestamp < 5 * 60 * 1000;
        if (!isRecent) {
          get().clearRelatedPrdModalState();
          return false;
        }

        return true;
      },

      markAsRestored: () => {
        set({
          isRestored: true,
        });
      },
    }),
    {
      name: 'wck-related-prd-modal-state',
      // 5분 후 자동으로 만료되도록 설정
      partialize: state => ({
        relatedPrdModalState: state.relatedPrdModalState,
        isRestored: state.isRestored,
      }),
    }
  )
);
